export const toArray = (source) => {
    return [...source];
};
